var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v(" SelectedConcept (Root.vue) ")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.root.id)+" - "+_vm._s(_vm.root.fsn.term)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }